import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const TableForBlog13 = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const minifigureImagePath = "/images/minifigures";

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/getTopMinifigureByYear.php`)
            .then(res => {
                if (!res.ok) throw new Error('Failed to fetch data');
                return res.json();
            })
            .then(json => {
                setData(json);
                setLoading(false);
            })
            .catch(err => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    if (loading) return <p className="text-center py-4">Loading data...</p>;
    if (error) return <p className="text-center py-4 text-red-400">Error: {error}</p>;

    return (
        <div className="flex justify-center items-center my-4">
            <table className="w-full">
                <thead>
                    <tr className="border-b border-white max-md:text-sm">
                        <th className="py-2 px-2 lg:px-8 text-center">Year</th>
                        <th className="py-2 px-2 lg:px-8 text-center hidden md:table-cell">Image</th>
                        <th className="py-2 px-2 lg:px-8 text-center">Minifigure</th>
                        <th className="py-2 px-2 lg:px-8 text-center hidden md:table-cell">Theme</th>
                        <th className="py-2 px-2 lg:px-8 text-center">Rating</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row) => (
                        <tr key={row.year} className="border-b border-white border-opacity-50 max-md:text-sm">
                            <td className="py-2 px-2 lg:px-8 text-center">{row.year}</td>
                            <td className="py-2 px-2 lg:px-8 text-center hidden md:table-cell">
                                <img
                                    src={`${minifigureImagePath}/${row.minifig_id}.png`}
                                    alt={row.minifig_name}
                                    className="h-16 object-contain mx-auto"
                                />
                            </td>
                            <td className="py-2 px-2 lg:px-8 text-center">
                                <Link
                                    to={`/results/${row.theme_url}/minifigures/${row.minifig_id}`}
                                    className="text-green-400 hover:underline"
                                >
                                    {row.minifig_name}
                                </Link>
                            </td>
                            <td className="py-2 px-2 lg:px-8 text-center hidden md:table-cell">{row.theme}</td>
                            <td className="py-2 px-2 lg:px-8 text-center">{Math.round(row.rating)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableForBlog13;
